export function translateConfig(
  envServiceProvider,
  fdTranslateModalProvider,
  fdTranslateProvider
) {
  'ngInject';

  const tenant = envServiceProvider.getTenant();
  const custom = envServiceProvider.getCustom();

  // Set customs to translate modal (use 'fino' custom for none tenant)
  fdTranslateModalProvider.setCustoms(custom);
  fdTranslateModalProvider.preferredCustom(tenant === 'none' ? 'fino' : tenant);

  // Activate translation module for localhost
  if (envServiceProvider.isLocalhost()) {
    fdTranslateProvider.config({
      hotkey: true
    });
  }
}
